export const ADMIN_CHARGE_OPTIONS = [5, 10, 15, 20];
export const DEFAULT_ADMIN_CHARGE = 5;
export const DEFAULT_ADMIN_CHARGE_TYPE = "percent";

export const isValidAdminCharge = (value) => {
  if (value === "" || value === null || value === undefined) return false;
  return ADMIN_CHARGE_OPTIONS.includes(Number(value));
};

export const normalizeAdminChargeValue = (value) => {
  const num = Number(value);
  if (ADMIN_CHARGE_OPTIONS.includes(num)) return num;
  return DEFAULT_ADMIN_CHARGE;
};

export const resolveAdminChargeFormFields = (pricing = {}) => {
  const storedType = pricing.admin_charge_type;
  const type =
    storedType === "flat" || storedType === "percent"
      ? storedType
      : DEFAULT_ADMIN_CHARGE_TYPE;
  const raw = pricing.admin_charge_value;
  const value =
    raw != null && raw !== ""
      ? String(raw)
      : type === "percent"
      ? String(DEFAULT_ADMIN_CHARGE)
      : "";

  return {
    admin_charge_type: type,
    admin_charge_value: value,
  };
};
